"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var q_play_core_1 = require("@nordicscreen/q-play-core");
var UploadMedia_1 = __importDefault(require("./UploadMedia"));
var react_i18next_1 = require("react-i18next");
var AccessControl_1 = __importDefault(require("@/Components/common/AccessControl"));
var types_1 = require("@/Types/types");
var react_admin_1 = require("react-admin");
var RALayout_1 = __importDefault(require("@/Layouts/RALayout"));
var MediaLibraryGridView_1 = __importDefault(require("./MediaLibraryGridView"));
var MediaLibraryListView_1 = __importDefault(require("./MediaLibraryListView"));
var q_play_components_1 = require("@nordicscreen/q-play-components");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
var free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
var MediaLibraryDataProvider_1 = __importDefault(require("./MediaLibraryDataProvider"));
var Breadcrumb_1 = __importDefault(require("./Breadcrumb"));
var ApiManager_1 = __importDefault(require("@/functions/ApiManager"));
var MediaLibrary_module_css_1 = __importDefault(require("./MediaLibrary.module.css"));
var NewFolderModal_1 = __importDefault(require("./NewFolderModal"));
var FolderAccessModal_1 = __importDefault(require("./FolderAccessModal"));
var q_play_core_2 = require("@nordicscreen/q-play-core");
var react_dnd_1 = require("react-dnd");
var react_dnd_html5_backend_1 = require("react-dnd-html5-backend");
var MediaLibrary = function (props) {
    var _a;
    var t = (0, react_i18next_1.useTranslation)().t;
    var logger = q_play_core_1.logManager.getLogger();
    var _b = (0, react_1.useState)("grid"), active = _b[0], setActive = _b[1];
    var _c = (0, q_play_components_1.useModal)(), isShown = _c.isShown, toggle = _c.toggle;
    var folderAccessModalState = (0, q_play_components_1.useModal)();
    var _d = (0, react_1.useState)(), folderAccessFolderId = _d[0], setFolderAccessFolderId = _d[1];
    var _e = (0, react_1.useState)([]), folders = _e[0], setFolders = _e[1];
    var _f = (0, react_1.useState)([]), media = _f[0], setMedia = _f[1];
    var _g = (0, react_1.useState)([]), selectedFolderIds = _g[0], setSelectedFolderIds = _g[1];
    var _h = (0, react_1.useState)([]), selectedMediaIds = _h[0], setSelectedMediaIds = _h[1];
    var _j = (0, react_1.useState)(null), rootFolderAsParentId = _j[0], setRootFolderAsParentId = _j[1];
    var rootFolderId = 0;
    var defaultBreadcrumb = [{ id: 0, name: t("home") }];
    var _k = (0, react_1.useState)(function () {
        var storedBreadcrumb = localStorage.getItem("breadcrumb");
        return storedBreadcrumb ? JSON.parse(storedBreadcrumb) : defaultBreadcrumb;
    }), breadcrumb = _k[0], setBreadcrumb = _k[1];
    var savedCollectionName = localStorage.getItem("collectionName") || "mediaCollection";
    var _l = (0, react_1.useState)(savedCollectionName), collectionName = _l[0], setCollectionName = _l[1];
    var loadFolderCollectionNames = function () {
        var savedMap = localStorage.getItem("folderCollectionNames");
        return savedMap ? new Map(JSON.parse(savedMap)) : new Map();
    };
    var _m = (0, react_1.useState)(loadFolderCollectionNames()), folderCollectionNames = _m[0], setFolderCollectionNames = _m[1];
    var currentFolderId = (0, react_1.useMemo)(function () { return breadcrumb[breadcrumb.length - 1].id; }, [breadcrumb]);
    var currentFolderName = (0, react_1.useMemo)(function () { return breadcrumb[breadcrumb.length - 1].name; }, [breadcrumb]);
    var _o = (0, react_1.useState)(""), searchQuery = _o[0], setSearchQuery = _o[1];
    var handleSearch = (0, react_1.useCallback)(function (query) {
        setSearchQuery(query);
    }, []);
    var debouncer = (0, react_1.useMemo)(function () { return new q_play_core_2.Debouncer(handleSearch, 300); }, [handleSearch]);
    var _p = (0, react_1.useState)(false), confirmationModalOpened = _p[0], setConfirmationModalOpened = _p[1];
    var onlineResourceManager = new q_play_core_1.OnlineResourceManager();
    var _q = (0, react_1.useState)([]), currentFolderPermissions = _q[0], setCurrentFolderPermissions = _q[1];
    var _r = (0, react_1.useState)(""), folderAccessFolderName = _r[0], setFolderAccessFolderName = _r[1];
    (0, react_1.useEffect)(function () {
        var serializedMap = JSON.stringify(Array.from(folderCollectionNames.entries()));
        localStorage.setItem("folderCollectionNames", serializedMap);
    }, [folderCollectionNames]);
    (0, react_1.useEffect)(function () {
        var savedFolderId = localStorage.getItem("selectedFolderId");
        var savedFolderName = localStorage.getItem("selectedFolderName");
        if (savedFolderId && savedFolderName) {
            fetchFolderContents(parseInt(savedFolderId), savedFolderName, false, false, true);
        }
        else {
            fetchFolderContents(rootFolderId, "Home", false, false, true);
        }
    }, []);
    (0, react_1.useEffect)(function () {
        if (currentFolderId === rootFolderId) {
            setCurrentFolderPermissions([]);
        }
    }, [currentFolderId]);
    var toggleNewFolderModal = function () {
        toggle();
    };
    var fetchFolderContents = function (folderId, folderName, updateBreadcrumb, updateCollectionName, updateFolderPermissions) {
        if (updateBreadcrumb === void 0) { updateBreadcrumb = true; }
        if (updateCollectionName === void 0) { updateCollectionName = true; }
        if (updateFolderPermissions === void 0) { updateFolderPermissions = true; }
        return __awaiter(void 0, void 0, void 0, function () {
            var response, folders_1, media_1, current, newCollectionName, permissionsArray, error_1;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, MediaLibraryDataProvider_1.default.getList("folders", {
                                filter: { folderId: folderId, q: searchQuery },
                                pagination: { page: 1, perPage: 1000 },
                                sort: { field: "id", order: "ASC" },
                            })];
                    case 1:
                        response = _b.sent();
                        folders_1 = response.data.filter(function (item) { return item.type === "folder"; });
                        media_1 = response.data.filter(function (item) { return item.type === "media"; });
                        current = response.data.find(function (item) { return item.type === "current"; });
                        setFolders(folders_1);
                        setMedia(media_1);
                        setFolderCollectionNames(function (prevState) {
                            var newState = new Map(prevState);
                            folders_1.forEach(function (folder) {
                                newState.set(folder.id, folder.collection_name);
                            });
                            return newState;
                        });
                        if (updateCollectionName) {
                            newCollectionName = folderId === 0
                                ? "mediaCollection"
                                : folderCollectionNames.get(folderId) || ((_a = folders_1.find(function (item) { return item.id === folderId; })) === null || _a === void 0 ? void 0 : _a.collection_name) || "mediaCollection";
                            setCollectionName(newCollectionName);
                            localStorage.setItem("collectionName", newCollectionName);
                        }
                        if (updateBreadcrumb) {
                            updateBreadcrumbState(folderId, folderName);
                        }
                        if (current && current.permission_names && updateFolderPermissions) {
                            permissionsArray = current.permission_names.split(",");
                            setCurrentFolderPermissions(permissionsArray);
                        }
                        setSelectedFolderIds([]);
                        setSelectedMediaIds([]);
                        localStorage.setItem("selectedFolderId", String(folderId));
                        localStorage.setItem("selectedFolderName", folderName);
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _b.sent();
                        if (error_1 instanceof react_admin_1.HttpError && error_1.status === 404) {
                            localStorage.removeItem("breadcrumb");
                            localStorage.removeItem("selectedFolderId");
                            localStorage.removeItem("selectedFolderName");
                            localStorage.removeItem("folderCollectionNames");
                            if (folderId !== rootFolderId) {
                                fetchFolderContents(rootFolderId, "Home", false, false, true);
                            }
                            setBreadcrumb(defaultBreadcrumb);
                        }
                        logger.error("Error fetching folder contents:", error_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    var updateBreadcrumbState = function (folderId, folderName) {
        var newCrumb = { id: folderId, name: folderName };
        var newBreadcrumb = breadcrumb.filter(function (crumb) { return crumb.id <= folderId; });
        if (!newBreadcrumb.find(function (crumb) { return crumb.id === folderId; })) {
            newBreadcrumb.push(newCrumb);
        }
        setBreadcrumb(newBreadcrumb);
        localStorage.setItem("breadcrumb", JSON.stringify(newBreadcrumb));
    };
    var setView = function (newView) {
        try {
            setActive(newView);
            setSelectedFolderIds([]);
            setSelectedMediaIds([]);
            localStorage.removeItem("RaStore.mediaLibrary.selectedIds");
            localStorage.setItem("activeView", newView);
        }
        catch (error) {
            logger.warn("Set media library view: " + error.message, error);
        }
    };
    (0, react_1.useEffect)(function () {
        var savedView = localStorage.getItem("activeView");
        if (savedView) {
            setActive(savedView);
        }
        fetchMediaFilesAsynchronously();
        getParentId();
    }, []);
    var fetchMediaFilesAsynchronously = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetchFolderContents(currentFolderId || rootFolderId, currentFolderName || "Home")];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var getParentId = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, parentIdToSet;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, ApiManager_1.default.getRootFolderId()];
                case 1:
                    response = _a.sent();
                    parentIdToSet = typeof response === "object" && response !== null ? response.id : response;
                    setRootFolderAsParentId(parentIdToSet);
                    return [2 /*return*/];
            }
        });
    }); };
    var handleCreateFolder = function (folderName) { return __awaiter(void 0, void 0, void 0, function () {
        var parentIdToUse, newFolderData, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    parentIdToUse = currentFolderId !== 0 ? currentFolderId : rootFolderAsParentId;
                    newFolderData = {
                        name: folderName,
                        parent_id: parentIdToUse !== null ? parentIdToUse : null,
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, MediaLibraryDataProvider_1.default.create("folders", { data: newFolderData })];
                case 2:
                    _a.sent();
                    return [4 /*yield*/, fetchFolderContents(currentFolderId || parentIdToUse, currentFolderName || "Home", false, false)];
                case 3:
                    _a.sent();
                    setSelectedFolderIds([]);
                    return [3 /*break*/, 5];
                case 4:
                    error_2 = _a.sent();
                    logger.error("Error creating folder:", error_2);
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var handleDeleteFolder = function (folderId) { return __awaiter(void 0, void 0, void 0, function () {
        var error_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    return [4 /*yield*/, MediaLibraryDataProvider_1.default.delete("folders", { id: folderId })];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, fetchFolderContents(currentFolderId || rootFolderId, currentFolderName || "Home", false)];
                case 2:
                    _a.sent();
                    setSelectedFolderIds(function (prev) {
                        var newSelectedIds = prev.filter(function (id) { return id !== folderId; });
                        localStorage.setItem("RaStore.mediaLibrary.selectedIds", JSON.stringify(newSelectedIds));
                        return newSelectedIds;
                    });
                    return [3 /*break*/, 4];
                case 3:
                    error_3 = _a.sent();
                    logger.error("Error deleting folder:", error_3);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handleDeleteMedia = function (collectionName, mediaId) { return __awaiter(void 0, void 0, void 0, function () {
        var error_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    return [4 /*yield*/, ApiManager_1.default.deleteMedia(collectionName, mediaId)];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, fetchFolderContents(currentFolderId || rootFolderId, currentFolderName || "Home", false)];
                case 2:
                    _a.sent();
                    setSelectedMediaIds(function (prev) {
                        var newSelectedIds = prev.filter(function (id) { return id !== mediaId; });
                        localStorage.setItem("RaStore.mediaLibrary.selectedIds", JSON.stringify(newSelectedIds));
                        return newSelectedIds;
                    });
                    return [3 /*break*/, 4];
                case 3:
                    error_4 = _a.sent();
                    logger.error("Error deleting media:", error_4);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var confirmSelectedFile = function () {
        if (props.sendEditorFileMessage) {
            var selectedMediaId_1 = selectedMediaIds[0];
            var selectedMedia = media.find(function (media) { return media.id === selectedMediaId_1; });
            props.sendEditorFileMessage(selectedMedia);
        }
    };
    var handleDownloadMedia = function (mediaIds) { return __awaiter(void 0, void 0, void 0, function () {
        var downloadMedia, link;
        return __generator(this, function (_a) {
            try {
                downloadMedia = media.find(function (item) { return item.id === mediaIds[0]; });
                link = document.createElement("a");
                link.href = "api/media-library/files/download/".concat(downloadMedia.collection_name, "/").concat(downloadMedia.id);
                link.download = downloadMedia.file_name || "download";
                link.click();
            }
            catch (error) {
                logger.error("Error downloading media:", error);
            }
            return [2 /*return*/];
        });
    }); };
    var handleBulkActionChange = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var action, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    action = event.target.value;
                    if (selectedMediaIds.length === 0 && selectedFolderIds.length === 0) {
                        logger.error("No folder or media selected");
                        return [2 /*return*/];
                    }
                    _a = action;
                    switch (_a) {
                        case "delete": return [3 /*break*/, 1];
                        case "download": return [3 /*break*/, 2];
                    }
                    return [3 /*break*/, 6];
                case 1:
                    setConfirmationModalOpened(true);
                    return [3 /*break*/, 7];
                case 2:
                    if (!(selectedMediaIds.length > 0)) return [3 /*break*/, 4];
                    return [4 /*yield*/, handleDownloadMedia(selectedMediaIds)];
                case 3:
                    _b.sent();
                    setSelectedMediaIds([]);
                    return [3 /*break*/, 5];
                case 4:
                    logger.error("No media selected for download");
                    _b.label = 5;
                case 5: return [3 /*break*/, 7];
                case 6: return [3 /*break*/, 7];
                case 7: return [2 /*return*/];
            }
        });
    }); };
    var handleConfirmBulkDelete = function () {
        if (selectedFolderIds.includes(currentFolderId)) {
            logger.error("Attempted to delete the currently viewed folder.");
            var filteredFolderIds = selectedFolderIds.filter(function (id) { return id !== currentFolderId; });
            setSelectedFolderIds(filteredFolderIds);
            if (filteredFolderIds.length > 0) {
                filteredFolderIds.forEach(function (id) { return handleDeleteFolder(id); });
                setSelectedFolderIds([]);
            }
        }
        else {
            if (selectedFolderIds.length > 0) {
                selectedFolderIds.forEach(function (id) { return handleDeleteFolder(id); });
                setSelectedFolderIds([]);
            }
        }
        if (selectedMediaIds.length > 0) {
            selectedMediaIds.forEach(function (originalId) { return handleDeleteMedia(collectionName, originalId); });
            setSelectedMediaIds([]);
        }
        setConfirmationModalOpened(false);
    };
    var handleFileDoubleClickAction = function (mediaId) {
        if (props.sendEditorFileMessage && props.mode === "editor") {
            props.sendEditorFileMessage(media.find(function (media) { return media.id === mediaId; }));
        }
    };
    var handleMoveMediaToFolder = function (mediaItem, folderId) {
        var targetFolderName = folderId === 0 ? "mediaCollection" : folderCollectionNames.get(folderId);
        if (targetFolderName) {
            var data = {
                collectionName: targetFolderName
            };
            onlineResourceManager.makeRequest("/api/media-library/files/".concat(mediaItem.id), "PATCH", JSON.stringify(data), {
                headers: {
                    "Content-Type": "application/json"
                }
            })
                .getResponseRaw()
                .then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    fetchFolderContents(currentFolderId, currentFolderName);
                }
                else {
                    logger.error("Error updating media with status code: ", response.status);
                }
            })
                .catch(function (error) {
                logger.error("Error updating media: ", error);
            });
        }
        else {
            logger.error("Target folder ID ".concat(folderId, " not found"));
        }
    };
    var handleMoveFolderToFolder = function (folder, parentId) {
        if (parentId !== folder.id) {
            var data = {
                parent_id: parentId === 0 ? rootFolderAsParentId : parentId
            };
            onlineResourceManager.makeRequest("/api/media-library/folders/".concat(folder.id), "PATCH", JSON.stringify(data), {
                headers: {
                    "Content-Type": "application/json"
                }
            })
                .getResponseRaw()
                .then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    fetchFolderContents(currentFolderId, currentFolderName);
                }
                else {
                    logger.error("Error updating folder with status code: ", response.status);
                }
            })
                .catch(function (error) {
                logger.error("Error updating folder: ", error);
            });
        }
        else {
            logger.error("Cannot move folder into itself");
        }
    };
    var handleChangeFolderName = function (folderId, newName) { return __awaiter(void 0, void 0, void 0, function () {
        var data, onlineResource, response_1, error_5;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    data = { name: newName };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    onlineResource = onlineResourceManager.makeJSONRequest("/api/media-library/folders/".concat(folderId), "PATCH", JSON.stringify(data));
                    return [4 /*yield*/, onlineResource.getResponseRaw()];
                case 2:
                    response_1 = _a.sent();
                    if (response_1.status >= 200 && response_1.status < 300) {
                        fetchFolderContents(currentFolderId, currentFolderName);
                    }
                    else {
                        response_1.json().then(function () {
                            logger.error("Error updating folder name with status code:", response_1.status);
                        }).catch(function (jsonError) {
                            logger.error("Error parsing JSON response for error handling:", jsonError);
                        });
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_5 = _a.sent();
                    logger.error("Error updating folder name:", error_5);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handleMoveMultipleMediaToFolder = function (mediaItems, folderId) {
        mediaItems.forEach(function (mediaItem) {
            handleMoveMediaToFolder(mediaItem, folderId);
        });
    };
    var handleMoveMultipleFoldersToFolder = function (folders, parentId) {
        folders.forEach(function (folder) {
            handleMoveFolderToFolder(folder, parentId);
        });
    };
    var openFolderAccessModal = function (folderId, folderName) {
        setFolderAccessFolderId(folderId);
        setFolderAccessFolderName(folderName);
        folderAccessModalState.toggle();
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_dnd_1.DndProvider, { backend: react_dnd_html5_backend_1.HTML5Backend },
            react_1.default.createElement("div", { className: MediaLibrary_module_css_1.default.container },
                react_1.default.createElement("div", { className: MediaLibrary_module_css_1.default["fixed-header"] },
                    props.sendEditorFileMessage && (react_1.default.createElement("div", { style: { display: "flex", justifyContent: "end" } },
                        react_1.default.createElement(q_play_components_1.Button, { dataCy: "selectFileButton", onClick: confirmSelectedFile, text: t("Add Media"), isDisabled: selectedMediaIds.length !== 1 || !((_a = media.find(function (media) { return media.id === selectedMediaIds[0]; })) === null || _a === void 0 ? void 0 : _a.mime_type.includes(props.mimeGroup)), style: {
                                height: "37px",
                                width: "120px"
                            } }))),
                    react_1.default.createElement("div", { style: { display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "15px" } },
                        react_1.default.createElement(Breadcrumb_1.default, { breadcrumb: breadcrumb, fetchFolderContents: fetchFolderContents, handleMoveMultipleMediaToFolder: handleMoveMultipleMediaToFolder, handleMoveMultipleFoldersToFolder: handleMoveMultipleFoldersToFolder, currentFolderId: currentFolderId, media: media, folders: folders })),
                    react_1.default.createElement("div", { className: "d-flex justify-content-between align-items-center flex-wrap" },
                        react_1.default.createElement("div", { className: "ns-font-family d-flex align-items-center" },
                            react_1.default.createElement("input", { type: "text", placeholder: t("Search"), onChange: function (e) { return debouncer.debounce(e.target.value); }, className: MediaLibrary_module_css_1.default["search-input"] }),
                            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { style: { marginLeft: "-34px" }, icon: pro_solid_svg_icons_1.faMagnifyingGlass, color: "var(--primary-color)" })),
                        react_1.default.createElement("div", { style: { display: "flex", justifyContent: "space-around", alignItems: "center", gap: "15px", minHeight: "55px" } },
                            react_1.default.createElement("div", null,
                                react_1.default.createElement(AccessControl_1.default, { resourceId: currentFolderId, resourceType: types_1.ResourceType.FOLDER, folderPermissions: currentFolderPermissions, conditionalChildren: [
                                        {
                                            permission: props.permissions.manage,
                                            children: (react_1.default.createElement("div", { className: "ns-font-family" },
                                                react_1.default.createElement(q_play_components_1.Select, { onChange: handleBulkActionChange, value: "", className: MediaLibrary_module_css_1.default["custom-select"], "data-cy": "mediaLibraryBulkActionSelect" },
                                                    react_1.default.createElement("option", { value: "", disabled: true }, t("Bulk actions")),
                                                    react_1.default.createElement("option", { value: "delete", disabled: selectedFolderIds.length === 0 && selectedMediaIds.length === 0, "data-cy": "mlBulkDelete" }, t("Delete")))))
                                        },
                                        {
                                            permission: props.permissions.write,
                                            children: (react_1.default.createElement("div", { className: "ns-font-family" },
                                                react_1.default.createElement(q_play_components_1.Select, { onChange: handleBulkActionChange, value: "", className: MediaLibrary_module_css_1.default["custom-select"], "data-cy": "mediaLibraryBulkActionSelect" },
                                                    react_1.default.createElement("option", { value: "", disabled: true }, t("Bulk actions")),
                                                    react_1.default.createElement("option", { value: "delete", disabled: (selectedFolderIds.length > 0) || (selectedMediaIds.length === 0), "data-cy": "mlBulkDelete" }, t("Delete")))))
                                        }
                                    ] })),
                            react_1.default.createElement(AccessControl_1.default, { optionalPermissions: __spreadArray([], props.permissions.manage, true), folderPermissions: currentFolderPermissions, resourceType: types_1.ResourceType.FOLDER },
                                react_1.default.createElement("div", { className: MediaLibrary_module_css_1.default.separator }),
                                react_1.default.createElement("div", { style: { display: "flex", gap: "15px" } },
                                    react_1.default.createElement(q_play_components_1.Button, { variant: "primary", size: "small", onClick: toggleNewFolderModal, className: MediaLibrary_module_css_1.default["action-icon-buttons"], "data-cy": "newFolderButton" },
                                        react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faFolderPlus, color: "var(--info-color)" })),
                                    react_1.default.createElement(NewFolderModal_1.default, { isShown: isShown, toggle: toggleNewFolderModal, createFolder: handleCreateFolder }))),
                            react_1.default.createElement("div", { className: MediaLibrary_module_css_1.default.separator }),
                            react_1.default.createElement("div", { style: { display: "flex", flexWrap: "wrap", minWidth: "95px" } },
                                react_1.default.createElement(q_play_components_1.Button, { variant: "empty", size: "small", style: { background: "#EFEFEF", fontSize: "15px", borderRadius: "4px" }, onClick: function () { return setView("grid"); }, className: active === "list" ? "opacity-50" : "opacity-100" },
                                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faGrid2, color: "var(--info-color)" })),
                                react_1.default.createElement(q_play_components_1.Button, { variant: "empty", size: "small", onClick: function () { return setView("list"); }, style: { marginLeft: "10px", background: "#EFEFEF", fontSize: "15px", borderRadius: "4px" }, className: active === "grid" ? "opacity-50" : "opacity-100" },
                                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faList, color: "var(--info-color)" })))))),
                react_1.default.createElement("div", { className: MediaLibrary_module_css_1.default["scrollable-view"] },
                    react_1.default.createElement(react_admin_1.Admin, { dataProvider: MediaLibraryDataProvider_1.default, disableTelemetry: true, layout: RALayout_1.default }, active === "grid" ? (react_1.default.createElement(react_admin_1.Resource, { name: "mediaLibrary", list: function () {
                            return react_1.default.createElement(MediaLibraryGridView_1.default, { folders: folders, media: media, onDeleteFolder: handleDeleteFolder, onDownloadMedia: handleDownloadMedia, onDeleteMedia: handleDeleteMedia, setSelectedFolderIds: setSelectedFolderIds, selectedFolderIds: selectedFolderIds, fetchFolderContents: fetchFolderContents, selectedMediaIds: selectedMediaIds, setSelectedMediaIds: setSelectedMediaIds, collectionName: collectionName, mediaDoubleClickHandler: handleFileDoubleClickAction, searchQuery: searchQuery, currentFolderId: currentFolderId, currentFolderName: currentFolderName, handleMoveMultipleMediaToFolder: handleMoveMultipleMediaToFolder, handleMoveMultipleFoldersToFolder: handleMoveMultipleFoldersToFolder, openFolderAccessModal: openFolderAccessModal, permissions: props.permissions, folderPermissions: currentFolderPermissions, handleChangeFolderName: handleChangeFolderName });
                        } })) : (react_1.default.createElement(react_admin_1.Resource, { name: "mediaLibrary", list: function () {
                            return react_1.default.createElement(MediaLibraryListView_1.default, { folders: folders, media: media, onDeleteFolder: handleDeleteFolder, onDownloadMedia: handleDownloadMedia, onDeleteMedia: handleDeleteMedia, setSelectedFolderIds: setSelectedFolderIds, selectedFolderIds: selectedFolderIds, fetchFolderContents: fetchFolderContents, selectedMediaIds: selectedMediaIds, setSelectedMediaIds: setSelectedMediaIds, collectionName: collectionName, currentFolderId: currentFolderId, mediaDoubleClickHandler: handleFileDoubleClickAction, searchQuery: searchQuery, handleChangeFolderName: handleChangeFolderName, permissions: props.permissions, handleMoveMultipleMediaToFolder: handleMoveMultipleMediaToFolder, handleMoveMultipleFoldersToFolder: handleMoveMultipleFoldersToFolder, openFolderAccessModal: openFolderAccessModal, folderPermissions: currentFolderPermissions });
                        } })))),
                react_1.default.createElement(AccessControl_1.default, { folderPermissions: currentFolderPermissions, resourceId: currentFolderId, resourceType: types_1.ResourceType.FOLDER, conditionalChildren: [
                        {
                            permission: __spreadArray(__spreadArray([], props.permissions.write, true), props.permissions.manage, true),
                            children: (react_1.default.createElement("div", { className: "d-flex justify-content-around", style: { marginTop: "50px" }, "data-cy": "uploadButton" },
                                react_1.default.createElement(UploadMedia_1.default, { updateFiles: fetchMediaFilesAsynchronously, t: t, collectionName: collectionName }))),
                        },
                        {
                            permission: props.permissions.read,
                            children: (react_1.default.createElement("div", { className: "d-flex justify-content-center", style: { marginTop: "50px" } },
                                react_1.default.createElement(UploadMedia_1.default, { disabled: true, t: t, collectionName: collectionName }))),
                        },
                    ] }),
                react_1.default.createElement(q_play_components_1.ConfirmationModal, { isShown: confirmationModalOpened, onClose: function () { return setConfirmationModalOpened(false); }, onConfirm: handleConfirmBulkDelete, onCancel: function () { return setConfirmationModalOpened(false); }, headerText: t("Confirm"), message: t("Are you sure you want to delete the selected items?"), actionRequired: true, confirmLabel: t("Yes"), cancelLabel: t("Cancel"), centered: true, dataCy: "deleteConfirmModal" }),
                react_1.default.createElement(FolderAccessModal_1.default, { isShown: folderAccessModalState.isShown, onClose: folderAccessModalState.toggle, resourceId: folderAccessFolderId, resourceName: folderAccessFolderName })))));
};
exports.default = MediaLibrary;
